import { NoTransformConfigurationError } from './transformers/NoTransformConfigurationError.mjs';

/**
 * @internal
 */
function assertFunction() {
    NoTransformConfigurationError("functional.assertFunction");
}
/**
 * @internal
 */
function assertParameters() {
    NoTransformConfigurationError("functional.assertParameters");
}
/**
 * @internal
 */
function assertReturn() {
    NoTransformConfigurationError("functional.assertReturn");
}
/**
 * @internal
 */
function assertEqualsFunction() {
    NoTransformConfigurationError("functional.assertEqualsFunction");
}
/**
 * @internal
 */
function assertEqualsParameters() {
    NoTransformConfigurationError("functional.assertEqualsParameters");
}
/**
 * @internal
 */
function assertEqualsReturn() {
    NoTransformConfigurationError("functional.assertEqualsReturn");
}
/**
 * @internal
 */
function isFunction() {
    NoTransformConfigurationError("functional.isFunction");
}
/**
 * @internal
 */
function isParameters() {
    NoTransformConfigurationError("functional.isParameters");
}
/**
 * @internal
 */
function isReturn() {
    NoTransformConfigurationError("functional.isReturn");
}
/**
 * @internal
 */
function equalsFunction() {
    NoTransformConfigurationError("functional.equalsFunction");
}
/**
 * @internal
 */
function equalsParameters() {
    NoTransformConfigurationError("functional.equalsParameters");
}
/**
 * @internal
 */
function equalsReturn() {
    NoTransformConfigurationError("functional.equalsReturn");
}
/**
 * @internal
 */
function validateFunction() {
    NoTransformConfigurationError("functional.validateFunction");
}
/**
 * @internal
 */
function validateParameters() {
    NoTransformConfigurationError("functional.validateReturn");
}
/**
 * @internal
 */
function validateReturn() {
    NoTransformConfigurationError("functional.validateReturn");
}
/**
 * @internal
 */
function validateEqualsFunction() {
    NoTransformConfigurationError("functional.validateEqualsFunction");
}
/**
 * @internal
 */
function validateEqualsParameters() {
    NoTransformConfigurationError("functional.validateEqualsParameters");
}
/**
 * @internal
 */
function validateEqualsReturn() {
    NoTransformConfigurationError("functional.validateEqualsReturn");
}

export { assertEqualsFunction, assertEqualsParameters, assertEqualsReturn, assertFunction, assertParameters, assertReturn, equalsFunction, equalsParameters, equalsReturn, isFunction, isParameters, isReturn, validateEqualsFunction, validateEqualsParameters, validateEqualsReturn, validateFunction, validateParameters, validateReturn };
//# sourceMappingURL=functional.mjs.map
